import script from "./BaseSkeletonPath.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSkeletonPath.vue?vue&type=script&setup=true&lang=js"

import "./BaseSkeletonPath.vue?vue&type=style&index=0&id=08563800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08563800"]])

export default __exports__